export default "__VITE_ASSET__Bqjqwt4P__"